import React from "react";
import Layout from "../layout/Layout";

const ComingSoon = () => {
  return (
    <Layout>
      <h1 className="max-w-md text-4xl font-bold md:text-5xl text-left">
        Coming Soon...
      </h1>
    </Layout>
  );
};

export default ComingSoon;
